export default __webpack_public_path__ + "static/O0101-aeb95c8a176f6ba16a9a766ec7b959ca.png";